module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-189.e7eed032.svg";